import { render, staticRenderFns } from "./CorporatePoster.vue?vue&type=template&id=447863c2&scoped=true"
import script from "./CorporatePoster.vue?vue&type=script&lang=js"
export * from "./CorporatePoster.vue?vue&type=script&lang=js"
import style0 from "./CorporatePoster.vue?vue&type=style&index=0&id=447863c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447863c2",
  null
  
)

export default component.exports